export const mobileCommon = {
  "common.no-access.title": "Sin Acceso",
  "common.no-access.message": "No tienes permiso para ver o editar este contenido.",
};

